<template>
<div>
    <div class="col backgroundForm">
        <div class="col col-md-10 offset-md-1">
            <div class="col col-md-6 offset-md-3">
                <div class="alert alert-info" role="alert">
                    <h4 class="alert-heading" align="center">DENUNCIAS</h4>
                </div>
            </div>
        </div>

        <button class="btn btn-success col-12 col-md-4 offset-md-8" data-toggle="tooltip" data-placement="top" title="Registra a la persona u empresa en la Base de Registros de Denuncias" @click="mRegisterPerson"><font-awesome-icon icon="plus" /> Registrar Persona u empresa</button>

       <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="exec-reg" data-toggle="tab" href="#reg-denounce" role="tab" aria-controls="nav-gral" aria-selected="true"><font-awesome-icon icon="plus" /> Registro Denuncia</a>

                <a class="nav-item nav-link" id="exec-approv-gral" data-toggle="tab" href="#denounce-complement" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="tasks" /> Complementar </a>

            </div>
        </nav>

        <div class="tab-content" id="nav-tabContent">
            <!-- Registro de la solicitud de ejecucion presupuestaria -->
            <div class="tab-pane fade show active" id="reg-denounce" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="row">
                    <div class="col-12 col-sm-6 offset-sm-3 alert alert-success" align="center">
                        Registro de Denuncia
                    </div>
                </div>
                <hr>
                <transition name="fade" mode="out-in">
                    <div class="form-row" v-if=" (cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && cDtsUser.roleAssign !== 'FINANCIERO') ">
                        <div class="form-group col-12 col-md-4 offset-md-4">
                            <label for="nombre_embarcacion">Capitania</label>  
                            <!-- listar las capitanias -->
                            <select name="captain_complaint" class="form-control" id="captain_complaint" v-model="dts_complaints.captain">
                                <option v-for="port in ports" :value="port.id" :key="port.id">{{ port.name_port }}</option>
                            </select>                         
                        </div>
                    </div>
                </transition>
                
                
                <div class="input-group col-12 col-md-4">
                    <h5 class="form-control-plaintext "> Denunciante(s)</h5>
                    <div class="input-group-prepend">
                        <button class="btn btn-outline-warning" data-toggle="tooltip" data-placement="top" title="Busca a la persona en la Base de Registros de Denuncias y si esta no se encuentra proceda a registrarla" @click="mShowSearchPerson('D', 'DENUNCIANTE')"><font-awesome-icon icon="search" /> Buscar Denunciante</button>
                    </div>
                </div>
                 
                <hr>
                
                <div class="table-responsive col-12 col-md-10 offset-md-1" v-if=" cGetPersonComplaint.findIndex(pc => (pc.type_select === 'D')) > -1 ">
                    <table class="table">
                        <thead>
                            <tr class="table-warning">
                                <th>Datos Denunciante</th>
                                <th># Identificacion</th>
                                <th>Persona</th>
                                <th>--</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for=" cgp in cGetPersonComplaint " :key="cgp.id_temp" >                              
                                <td v-if="cgp.type_select==='D'">{{ cgp.complete }} </td>
                                <td v-if="cgp.type_select==='D'">{{ cgp.identification }}</td>
                                <td v-if="cgp.type_select==='D'">{{ cgp.type_person }}</td>
                                <td v-if="cgp.type_select==='D'" @click="mRemovePerson(cgp)"><button class="btn btn-danger"><font-awesome-icon icon="minus-circle" /></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="knowDenounced.value" @click="mKnowDenounced">
                    <label class="custom-control-label" for="customSwitch1"><b>{{ knowDenounced.text }}</b> Conoce los generales del Sindicado</label>
                </div>
                <div class="input-group col-12 col-md-6">
                    <h5 class="form-control-plaintext "> Denunciado(s) o Sindicado(s)</h5>
                    <div class="input-group-prepend">
                        <transition mode="out-in" name="fade">
                        <button class="btn btn-outline-danger" data-toggle="tooltip" data-placement="top" title="Busca a la persona DENUNCIADA en la Base de Informacion y si esta no se encuentra proceda a registrarla" @click="mShowSearchPerson('S', 'SINDICADO O DENUNCIADO')" v-if="knowDenounced.value"><font-awesome-icon icon="search" /> Buscar Denunciado</button>
                        </transition>
                    </div>
                    
                </div>
                
                <div class="form-group col-10 offset-md-1" v-if="!knowDenounced.value">
                    <label for="description-denounced">Descripcion del Denunciado o Sindicado</label>
                    <textarea name="description-denounced" id="desc-denounced" cols="30" rows="2" class="form-control" v-model="dts_complaints.descriptionDenounced"></textarea>
                </div>
                <hr>

                <div class="table-responsive col-12 col-md-10 offset-md-1" v-if=" cGetPersonComplaint.findIndex(pc => (pc.type_select === 'S')) > -1 ">
                    <table class="table">
                        <thead>
                            <tr class="table-danger">
                                <th>Datos Denunciado</th>
                                <th># Identificacion</th>
                                <th>Persona</th>
                                <th>--</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for=" cgp in cGetPersonComplaint " :key="cgp.id_temp">
                                <td v-if="cgp.type_select==='S'">{{ cgp.complete }} </td>
                                <td v-if="cgp.type_select==='S'">{{ cgp.identification }}</td>
                                <td v-if="cgp.type_select==='S'">{{ cgp.type_person }}</td>
                                <td v-if="cgp.type_select==='S'" @click="mRemovePerson(cgp)"><button class="btn btn-danger"><font-awesome-icon icon="minus-circle" /></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="customSwitch2" v-model="knowVictim.value" @click="mKnowVictim">
                    <label class="custom-control-label" for="customSwitch2"> <b>{{knowVictim.text}}</b> Conoce los Generales de la victima</label>
                </div>
                <div class="input-group col-12 col-md-3">
                    <h5 class="form-control-plaintext "> Victima</h5>
                    <div class="input-group-prepend">
                        <transition mode="out-in" name="fade">
                        <button class="btn btn-outline-info" data-toggle="tooltip" data-placement="top" title="Busca a la persona citada como VICTIMA en la Base de Informacion y si esta no se encuentra proceda a registrarla" @click="mShowSearchPerson('V', 'VICTIMA')" v-if="knowVictim.value"><font-awesome-icon icon="search" /> Buscar</button>
                        </transition>
                    </div>
                </div>
                 
                 <div class="form-group col-10 offset-md-1" v-if="!knowVictim.value">
                    <label for="description-victim">Descripcion de la Victima</label>
                    <textarea name="description-victim" id="desc-victim" cols="30" rows="2" class="form-control" v-model="dts_complaints.descriptionVictim"></textarea>
                </div>
                <hr>
                
                <div class="table-responsive col-12 col-md-10 offset-md-1" v-if=" cGetPersonComplaint.findIndex(pc => (pc.type_select === 'V')) > -1 ">
                    <table class="table">
                        <thead>
                            <tr class="table-info">
                                <th>Datos Victima</th>
                                <th># Identificacion</th>
                                <th>Persona</th>
                                <th>--</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for=" cgp in cGetPersonComplaint " :key="cgp.id_temp">
                                <td v-if="cgp.type_select==='V'">{{ cgp.complete }} </td>
                                <td v-if="cgp.type_select==='V'">{{ cgp.identification }}</td>
                                <td v-if="cgp.type_select==='V'">{{ cgp.type_person }}</td>
                                <td v-if="cgp.type_select==='V'" @click="mRemovePerson(cgp)"><button class="btn btn-danger"><font-awesome-icon icon="minus-circle" /></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="form-group col-12 col-md-2">
                        <label for="date_complaint">Fecha del Hecho</label>
                        <datetime v-model="dts_complaints.date" type="date" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" :format="{year:'numeric', month:'long', day:'numeric'}" placeholder="Seleccione la Fecha" title="Fecha de Conclusion" value-zone="America/La_Paz"></datetime>
                    </div>
                    <div class="form-group col-12 col-md-3">
                        <label for="time_complaint" class="labelBlack">Hora Hecho <span class="required-text">*</span></label>
                        <datetime v-model="aux_time" type="time" :phrases="{ok: 'Aceptar', cancel: 'Cerrar'}" input-class="form-control" placeholder="Indique la Hora" title="Hora Conclusion" value-zone="America/La_Paz"></datetime>                                
                    </div>
                    <div class="form-group col-12 col-md-4">
                        <label for="type_complaint">Tipo de Denuncia</label>
                        <select name="type_complaint" id="type_complaint" class="form-control" v-model="aux_type">
                            <option v-for="rp in types_denounced" :key="rp.id" :value="rp">{{rp.detail}}</option>
                        </select>
                    </div>
                    <div class="form-group col-12 col-md-1">
                        <label for="btn-update">Actualizar</label><br>
                        <button class="btn- btn-danger" @click="mCallTypesComplaint"><font-awesome-icon icon="sync-alt" size="2x" /></button>
                    </div>
                    <div class="form-group col-12 col-md-1">
                        <label for="btn-update">Nuevo</label><br>
                        <button class="btn- btn-info" @click="mRegNewParam"><font-awesome-icon icon="plus" size="2x" /></button>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-12 col-md-6">
                        <label for="dite_done">Lugar del Hecho <span class="required-text">*</span></label>
                        <input type="text" v-model="dts_complaints.site_done" class="form-control" id="dite_done" placeholder="ZONA/BARRIO/PROVINCIA"  autocomplete="off">
                    </div>
                </div>
                <div class="form-group">
                    <label for="description_done">Descripcion del Hecho</label>
                    <textarea name="description_done" id="descrpiption_done" v-model="dts_complaints.detail_done" cols="30" rows="3" class="form-control"></textarea>
                </div>
                <button class="btn btn-danger col-12 col-md-2 offset-md-5" @click="mSaveComplaint"><font-awesome-icon icon="save" size="2x" /></button>
            </div>

            <!-- Complementacion de la denuncia -->
            <div class="tab-pane fade" id="denounce-complement" role="tabpanel" aria-labelledby="nav-capitan-tab">
                <br>
                <div class="alert alert-info col col-md-6 offset-md-3">El sistema permite la modificacion de una denuncia hasta 5 dias despues de su registro en sistema.</div>

                <transition name="fade" mode="out-in">

                    <div v-if="complaint_edit.code > 0" class="panel panel-default">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th>Edicion de Denuncia</th>
                                    <th colspan="2"><a href="#current-pane" class="close" data-dismiss="alert" aria-label="close" id="hide" @click="mCloseEdit">&times;</a></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><b>Tipo Denuncia</b></td>
                                    <td><b>Fecha del Hecho</b></td>
                                    <td><b>Fecha de Registro</b></td>
                                </tr>
                                <tr>
                                    <td>{{ complaint_edit.type }}</td>
                                    <td>{{ complaint_edit.date_complaint }}</td>
                                    <td>{{ complaint_edit.date_system }}</td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>Sitio del Hecho</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3">{{ complaint_edit.site_complaint }}</td>
                                </tr>
                                <tr>
                                    <td colspan="3"><b>Descripcion del Hecho</b></td>
                                </tr>
                                <tr>
                                    <td colspan="3">{{ complaint_edit.description_done }}</td>
                                </tr>
                                <tr>
                                    <td><b>Denunciante(s):</b> <button class="btn btn-danger" @click="mShowSearchPersonEdit('D', 'DENUNCIANTE')"><font-awesome-icon icon="plus"/></button></td>
                                </tr>
                                
                                <tr v-for="cpers in complaint_edit.persons" :key="cpers.code" >
                                    <td v-if="cpers.type_relation === 'D'">{{ cpers.name }} {{ cpers.first_last_name }} {{ cpers.second_last_name }} - {{ cpers.identification }}</td>
                                    <td v-if="cpers.type_relation === 'D'">{{ cpers.type_person === 'N' ? 'NATURAL':'JURIDICA' }}</td>
                                    <td v-if="cpers.type_relation === 'D'">S/E</td>
                                </tr>

                                <table class="table" v-if=" cGetPersonComplaintEdit.findIndex(pc => (pc.type_select === 'D')) > -1 ">
                                    <tr v-for="cpersedit in cGetPersonComplaintEdit" :key="cpersedit.id_temp">
                                        <td v-if="cpersedit.type_select === 'D'">{{ cpersedit.complete }} {{ cpersedit.identification}}</td>
                                        <td v-if="cpersedit.type_select === 'D'">{{ cpersedit.type_person }}</td>
                                        <td v-if="cpersedit.type_select === 'D'"><button class="btn btn-danger" @click="mRemovePersonEdit(cpersedit)"> <font-awesome-icon icon="minus-circle"/></button></td>
                                    </tr>
                                </table>
                                <tr>
                                    <td colspan="3"><b>Denunciado(s):</b> <button class="btn btn-info" @click="mShowSearchPersonEdit('S', 'DENUNCIADO')"><font-awesome-icon icon="plus"/></button></td>
                                </tr>
                                <tr v-if="complaint_edit.exists_denounced === 'N'">
                                    <td colspan="3">{{complaint_edit.description_denounced}}</td>
                                </tr>
                                <tr v-else v-for="cpers in complaint_edit.persons" :key="cpers.code">
                                    <td v-if="cpers.type_relation === 'S'">{{ cpers.name }} {{ cpers.first_last_name }} {{ cpers.second_last_name }} - {{ cpers.identification }}
                                    </td>
                                    <td v-if="cpers.type_relation === 'S'">{{ cpers.type_person === 'N' ? 'NATURAL':'JURIDICA' }}</td>
                                    <td v-if="cpers.type_relation === 'S'">S/E</td>
                                </tr>
                                <table class="table" v-if=" cGetPersonComplaintEdit.findIndex(pc => (pc.type_select === 'S')) > -1 ">
                                    <tr v-for="cpersedit in cGetPersonComplaintEdit" :key="cpersedit.id_temp">
                                        <td v-if="cpersedit.type_select === 'S'">{{ cpersedit.complete }} {{ cpersedit.identification}}</td>
                                        <td v-if="cpersedit.type_select === 'S'">{{ cpersedit.type_person }}</td>
                                        <td v-if="cpersedit.type_select === 'S'"><button class="btn btn-danger" @click="mRemovePersonEdit(cpersedit)"> <font-awesome-icon icon="minus-circle"/></button></td>
                                    </tr>
                                </table>
                                <tr>
                                    <td colspan="3"><b>Victima(s):</b> <button class="btn btn-success" @click="mShowSearchPersonEdit('V', 'VICTIMA')"><font-awesome-icon icon="plus"/></button></td>
                                </tr>
                                <tr v-if="complaint_edit.know_victim === 'N'">
                                    <td colspan="3">{{complaint_edit.description_denounced}}</td>
                                </tr>
                                <tr v-else v-for="cpers in complaint_edit.persons" :key="cpers.code">
                                    <td v-if="cpers.type_relation === 'V'"><span >{{ cpers.name }} {{ cpers.first_last_name }} {{ cpers.second_last_name }} - {{ cpers.identification }}  </span>
                                    </td>
                                    <td v-if="cpers.type_relation === 'V'">{{ cpers.type_person === 'N' ? 'NATURAL':'JURIDICA' }}</td>
                                    <td v-if="cpers.type_relation === 'V'">S/E</td>
                                </tr>
                                <table class="table" v-if=" cGetPersonComplaintEdit.findIndex(pc => (pc.type_select === 'V')) > -1 ">
                                    <tr v-for="cpersedit in cGetPersonComplaintEdit" :key="cpersedit.id_temp">
                                        <td v-if="cpersedit.type_select === 'V'">{{ cpersedit.complete }} {{ cpersedit.identification}}</td>
                                        <td v-if="cpersedit.type_select === 'V'">{{ cpersedit.type_person }}</td>
                                        <td v-if="cpersedit.type_select === 'V'"><button class="btn btn-danger" @click="mRemovePersonEdit(cpersedit)"> <font-awesome-icon icon="minus-circle"/></button></td>
                                    </tr>
                                </table>
                                <tr>
                                    <td><b>Apendidos(s):</b> <button class="btn btn-warning" @click="mShowSearchPersonEdit('AP', 'APRENDIDOS')"><font-awesome-icon icon="plus"/></button></td>
                                </tr>
                                
                                <tr v-for="cpersedit in cGetPersonComplaintEdit" :key="cpersedit.id_temp">
                                        <td v-if="cpersedit.type_select === 'AP'">{{ cpersedit.complete }} {{ cpersedit.identification}}</td>
                                        <td v-if="cpersedit.type_select === 'AP'">{{ cpersedit.type_person }}</td>
                                        <td v-if="cpersedit.type_select === 'AP'"><button class="btn btn-danger" @click="mRemovePersonEdit(cpersedit)"> <font-awesome-icon icon="minus-circle"/></button></td>
                                </tr>
                                <tr>
                                    <td><b>Arrestados(s):</b> <button class="btn btn-secondary" @click="mShowSearchPersonEdit('AR', 'ARRESTADOS')"><font-awesome-icon icon="plus"/></button></td>
                                </tr>
                                
                                <tr v-for="cpersedit in cGetPersonComplaintEdit" :key="cpersedit.id_temp">
                                        <td v-if="cpersedit.type_select === 'AR'">{{ cpersedit.complete }} {{ cpersedit.identification}}</td>
                                        <td v-if="cpersedit.type_select === 'AR'">{{ cpersedit.type_person }}</td>
                                        <td v-if="cpersedit.type_select === 'AR'"><button class="btn btn-danger" @click="mRemovePersonEdit(cpersedit)"> <font-awesome-icon icon="minus-circle"/></button></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="form-group">
                            <label for="resena_caso"><b>Reseña del Caso</b></label>
                            <textarea class="form-control" name="resena_caso" id="resena_caso" cols="50" rows="3" autocomplete="off" v-model="complaint_edit.resena_case"></textarea>
                        </div>
                        <div class="form-group">
                            <label for="secuestro"><b>Detalle del secuestro Objeto, vehiculo, mercancia</b></label>
                            <textarea class="form-control" name="secuestro" id="secuestro" cols="50" rows="3" autocomplete="off" v-model="complaint_edit.detail_vehicles"></textarea>
                        </div>
                    

                        <button class="btn btn-info col-12 col-md-2 offset-md-4" @click="mUpdateComplaint"><font-awesome-icon icon="sync-alt" size="2x" /></button>
                        <button class="btn btn-danger col-12 col-md-2" @click="mCloseEdit"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de denuncia -->
                    <div v-else>
                        <div class="input-group mb-3 col-12 col-md-6 offset-md-3" v-if=" (cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && cDtsUser.roleAssign !== 'FINANCIERO') ">
                            <!-- listar las capitanias  si es administrador y si es de capitania nada-->
                            <select name="captain_uuss" class="form-control" id="captain_uuss" @change="mClearList" v-model="captain_edit">
                                <option v-for="pt in ports" :value="pt.id" :key="pt.id">{{ pt.name_port }}</option>
                            </select>
                            <div class="input-group-append">
                                <button class="btn btn-outline-info" @click="mSearchComplaint()">
                                    <font-awesome-icon icon="list"/>
                                </button>
                            </div>
                        </div>
                        <button class="btn btn-info col-12 col-md-2 offset-md-5" v-else @click="mSearchComplaint()">
                            <font-awesome-icon icon="list"/>
                        </button>

                        <div class="table-responsive" >
                            <table class="table table-hover" v-if="complaints_edit.length > 0">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Tipo Denuncia</th>
                                        <th>Fecha del Hecho</th>
                                        <th>Fecha Registro</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(cr, key) in complaints_edit" :key="cr.code">
                                        <td>{{ key+1 }}</td>
                                        <td>{{ cr.type_complaint }} No. {{ cr.correlative }}/{{ cr.yearc }}</td>
                                        <td>{{ cr.date_done }}</td>
                                        <td>{{ cr.date_system }}</td>
                                        <td>
                                            <button class="btn btn-success" @click="mSelectComp(cr.code)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>

            </div>
        </div>        

    </div>

    <modal-search-person :id-modal="idModalSearchPerson" :type-select="typeSelectPerson" :title="titleModal" :model="modelSearch" ></modal-search-person>
    <modal-search-person :id-modal="idModalSearchPersonEdit" :type-select="typeSelectPersonEdit" :title="titleModalEdit" :model="modelSearchPerson" ></modal-search-person>
    <modal-new-person :id-modal="idModalNewPerson"></modal-new-person>
    <modal-reg-global :id-modal="parModalRegGlobal.id" :title="parModalRegGlobal.title" :par-server="parModalRegGlobal.parametro"></modal-reg-global>
    <modal-loading :id-modal="idModalProgress" :title="titleModal" :status-send="sendDispatch"></modal-loading>
    <modal-report :id-modal-report="idModalReport" :title="modalRepTitle" :content="modalRepContent" :url-r="urlReport" :id-report="idReporte" ></modal-report>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';

import modalSearchPerson from './modalSearchPerson';
import modalNewPerson from './modalNewPerson';
import modalLoading from '../modal/modalLoading';
import modalRegGlobal from '../modal/modalRegGlobal'
import modalReport from '../modal/modalReport';

export default {
    name:'complaints',
    data(){
        return{
            complaint_edit:{
                code:0,
                type:null,
                date_complaint:null,
                date_system:null,
                site_complaint:null,
                description_done:null,
                persons:[],
                description_victim:null,
                description_denounced:null,
                exists_denounced:null,
                known_victim:null,
                resena_case:null,
                detail_vehicles:null
            },
            captain_edit:0,
            complaints_edit:[],
            idModalReport:'pdfDenounce',
            modalRepTitle:'Denuncia',
            modalRepContent:'',
            urlReport:'pdfDenounce',
            idReporte:0,
            idModalProgress:'loadingDenounce',
            titleModal:'Registrando',
            sendDispatch:true,
            idModalSearchPerson:'idSearchPerson',
            idModalSearchPersonEdit:'idSearchPersonEditComp',
            modelSearch:'sComplaintsPersons/addPersonComplaint',
            modelSearchPerson:'sComplaintsPersonsEdit/addPersonComplaintEdit',
            idModalNewPerson:'idNewPerson',            
            getPersonComplete:[],
            typeSelectPerson:'D',
            typeSelectPersonEdit:'D',
            titleModal:'Denunciante',
            titleModalEdit:'Denunciante',
            knowDenounced:{
                text:'SI',
                value:true
            },
            knowVictim:{
                text:'SI',
                value:true
            },
            types_denounced:[],
            aux_type:{
                id:0,
                detail:null
            },
            aux_time:null,
            dts_complaints:{
                captain:0,
                type:0,
                site_done:null,
                detail_done:null,
                date:null,
                time:null,
                complaint:[],
                denounced:[],
                victim:[],
                knowdenounced:true,
                knowvictim:true,
                descriptionDenounced:null,
                descriptionVictim:null
            },
            parModalRegGlobal:{
                id:'global_complaints',
                title:'Registro detalle de Denuncia',
                parametro:'complaint'
            },
            ports:[]
        }
    },
    mounted(){
        this.mInitTooltip();
        this.mCallTypesComplaint();
        this.mVerifyDuplicated();
    },
    methods:{
        mUpdateComplaint(){
            console.log('llegando a la actualizacion de la denuncia')
            // quitamos el metodo computed que pide que añada mas personas
            // if(this.cGetPersonComplaintEdit.length>0){
                let message = {
                    title: 'Actualizar Denuncia',
                    body: `¿Desea Actualizar la denuncia <b>${this.complaint_edit.type}</b>?`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            this.mShowModal(this.idModalProgress);
                            // aca actualizamos el registro de la denuncia
                            this.cGetPersonComplaintEdit.forEach(dt=>{
                                console.log(dt);
                                let new_person={
                                    id_person:dt.id_person,
                                    identification:dt.identification,
                                    celular:0,
                                    expedido:null,
                                    first_laste_name:null,
                                    name:dt.complete,
                                    second_last_name:null,
                                    type_person:null,
                                    type_relation:dt.type_select
                                }
                                let fpi=this.complaint_edit.persons.findIndex(fipo => (fipo.id_person === new_person.id_person && fipo.type_relation === new_person.type_relation ) );
                                if(fpi === -1){
                                    this.complaint_edit.persons.push(new_person);
                                }
                            });
                            // console.log(this.cGetPersonComplaintEdit);
                            console.log(this.complaint_edit);
                            let update_denounced=await axios.post(`updateDenounced?api_token=${Vue.auth.getToken()}`, qs.stringify(this.complaint_edit));
                            console.log(update_denounced);
                            // posterior cerramos el formulario y mandamos a la ventana anterior
                            this.complaint_edit.code=0;
                            // // console.log(this.dts_complaints);
                            if(update_denounced.data.status){
                                    toastr.success(update_denounced.data.respuesta,'Exito');                                    
                                    this.mClearFormRegister();                                        
                                    setTimeout(()=>{                                            
                                        this.mCloseModal(this.idModalProgress);
                                        this.modalRepContent='';
                                        this.idReporte=update_denounced.data.id_rep;
                                        // this.mModalReportShow();
                                        this.mShowModal(this.idModalReport);
                                    },1000)
                                }else{
                                    toastr.error(update_denounced.data.respuesta, 'Error')
                                        setTimeout(()=>{                                            
                                            this.mCloseModal(this.idModalProgress);
                                        },1000)
                                }                              

                        }catch(err){
                            // console.log(err);
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error D-01')
                                setTimeout(()=>{
                                    
                                    this.mCloseModal(this.idModalProgress);
                                },500)
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la denuncia')
                        // console.log(this.s_pro_ordop);
                        // toastr.warning(s_new_param.data.respuesta, 'Error');                                    
                    }
                })
            // }
        },
        mVerifyDuplicated(){
            setInterval(()=>{
                
                if(this.cGetPersonComplaintEdit.length > 0){
                    // verificamos que no exista duplicados en el storage y los que llego del servidor
                    console.log(`iniciando la verificacion de duplicidad`)
                    
                    this.mCheckDuplicate();
                    
                }
            }, 15000)
        },
        mCheckDuplicate(){
            let ca=this.complaint_edit.persons;

                    if(ca.length >= 0){
                        ca.forEach(el => {
                            console.log(el);
                            let idx = this.cGetPersonComplaintEdit.findIndex( dts => dts.identification === el.identification && el.type_relation === dts.type_select );
                            console.log(idx);
                            if(idx > -1){
                                this.$store.dispatch('sComplaintsPersonsEdit/deletePersonComplaintSpecifyEdit', idx);
                            }
                        });                   
                        
            }
        },
        mCloseEdit(){
            this.complaint_edit.code=0;
            this.complaint_edit.type=null;
            this.complaint_edit.date_complaint=null;
            this.complaint_edit.date_system=null;
            this.complaint_edit.site_complaint=null;
            this.complaint_edit.description_done=null;
            this.complaint_edit.persons=[];
            this.complaint_edit.description_victim=null;
            this.complaint_edit.description_denounced=null;
            this.complaint_edit.exists_denounced=null;
            this.complaint_edit.known_victim=null;
        },
        async mSelectComp(idc){
            this.mShowModal(this.idModalProgress);
            
            try {
                let dtcom=await axios.get(`getDtsCom/${idc}?api_token=${Vue.auth.getToken()}`);
                // console.log(dtcom.data);
                    
                    this.complaint_edit.code=dtcom.data.master[0].code;
                    this.complaint_edit.type=`${dtcom.data.master[0].type_complaint} ${dtcom.data.master[0].correlative} / ${dtcom.data.master[0].yearc}`;
                    this.complaint_edit.date_complaint= this.$dateWrite(dtcom.data.master[0].date_done);
                    this.complaint_edit.date_system=this.$dateWrite(dtcom.data.master[0].date_system);
                    this.complaint_edit.site_complaint=dtcom.data.master[0].site_done;
                    this.complaint_edit.description_done=dtcom.data.master[0].detail_done;
                    this.complaint_edit.persons=dtcom.data.persons;
                    this.complaint_edit.description_victim=dtcom.data.master[0].detail_victim;
                    this.complaint_edit.description_denounced=dtcom.data.master[0].detail_denounced;
                    this.complaint_edit.exists_denounced=dtcom.data.master[0].exists_denounced;
                    this.complaint_edit.known_victim=dtcom.data.master[0].known_victim;
                    this.complaint_edit.resena_case=dtcom.data.master[0].review_done;
                    this.complaint_edit.detail_vehicles=dtcom.data.master[0].kidnaped_done;
                    // console.log(this.complaint_edit);
            } catch (error) {
                setTimeout(()=>{
                    this.mCloseModal(this.idModalProgress);
                },500)
            }
            setTimeout(()=>{
                this.mCloseModal(this.idModalProgress);
            },500)

        },
        mClearList(){
            this.complaints_edit=[];
        },
        async mSearchComplaint(){
            // aqui debemos validar si es admnistrador enviar su rol y si es operador con el id de la capitania
            // this.captain_edit;
            // console.log(this.cDtsUser.roleAssign)
            if(this.cDtsUser.roleAssign === 'OPERADOR CAPITANIA'){
                this.captain_edit=this.cDtsUser.portId;
            }else if(this.captain_edit === 0){
                // aqui solicitamos la lista al servidor
                toastr.warning('seleccione una Capitania', 'Advertencia')
                return false;
            }

            // console.log(`${this.captain_edit} el rol ${this.cDtsUser.role}`);
            let dtscom = await axios.get(`searchEditComplaint/${this.captain_edit}/${this.cDtsUser.role}?api_token=${Vue.auth.getToken()}`);
            // console.log(dtscom);
            if(dtscom.data.status){
                this.complaints_edit=[];
                let auxdts=dtscom.data.data;
                auxdts.forEach(e=>{
                    let tdt={
                        code:e.code,
                        correlative:e.correlative,
                        date_done:this.$dateWrite(e.date_done),
                        date_system:this.$dateWrite(e.date_system),
                        type_complaint:e.type_complaint,
                        yearc:e.yearc
                    }
                    this.complaints_edit.push(tdt);
                })
                

                // this.$dateWrite('2021-01-12');
                console.log(this.complaints_edit);
            }else{
                // si ocurrio algun problema
                toastr.info(dtscom.data.response);
            }

            console.log(`enviamos al servidor la solicitud de modificacion de denuncia`);
        },
        mVerifyComplaint(){
            let denounced=this.cGetPersonComplaint.findIndex( i => i.type_select === 'D' );
            let sindicado=this.cGetPersonComplaint.findIndex( i => i.type_select === 'S' );
            let victim=this.cGetPersonComplaint.findIndex( i => i.type_select === 'V' );

            if(denounced <= -1){
                toastr.warning('Debe Indicar los Generales del Denunciante');
                return false;
            }
            if(sindicado <= -1 && this.knowDenounced.value ){
                toastr.warning('Debe indicar datos del Sindicado o Denunciado');
                return false;
            }
            
            // if( !this.knowDenounced.value ){
            //     if(this.dts_complaints.descriptionDenounced === null ) {
            //         toastr.warning('Describa lo datos del Sindicado o Denunciado');
            //         return false;
            //     }                
            // }

            if(victim <= -1 && this.knowVictim.value ){
                toastr.warning('Debe indicar datos de la Victima');
                return false;
            }

            if( !this.knowVictim.value ){
                if(this.dts_complaints.descriptionVictim === null ) {
                    toastr.warning('Describa los datos de la Victima');
                    return false;
                }                
            }

            let adi=this.dts_complaints.date.split('T');
            this.dts_complaints.date=adi[0];

            if( this.dts_complaints.date === null || !(this.dts_complaints.date.length === 10) ){
                toastr.error('La fecha es incorrecta', 'Error');
                return false;
            }

            let ah=this.aux_time.split('T');
            console.log(ah[1]);
            let ah2=ah[1].split(':');
            this.dts_complaints.time=ah2[0]+ah2[1];
            
            if( this.dts_complaints.time === null ||!(this.dts_complaints.time.length >= 3 ) || !(this.dts_complaints.time.length <= 4)  || this.dts_complaints.time >=2400 ){
                toastr.error('La Hora es incorrecta', 'Error');
                return false;
            }

            if(this.aux_type.id === 0){
                toastr.error('Indique el tipo de Denuncia', 'Error');
                return false;
            }

            if(this.dts_complaints.detail_done === null   ){
                toastr.error('Indique la descripcion de los hechos', 'Error');
                return false;
            }

            if(this.cDtsUser.roleAssign !== 'OPERADOR CAPITANIA' && this.cDtsUser.roleAssign !== 'FINANCIERO'){
                if(this.dts_complaints.captain === 0){
                    toastr.error('Seleccione una capitania', 'Error');
                    return false;
                }
            }else{
                // asignamos el valor de la capitania
                this.dts_complaints.captain=this.cDtsUser.portId;
            }


            return true;
        },
        mSaveComplaint(){
            if(this.mVerifyComplaint() ){
                let message = {
                    title: 'Registro Denuncia',
                    body: `¿Desea Registrar la denuncia <b>${this.aux_type.detail}</b>?`
                }
                
                let npr=new Promise((resolve, reject)=>{
                    this.$dialog
                    .confirm(message)
                    .then(function(dialog) {
                        resolve(true);          
                    })
                    .catch(function() {
                        resolve(false);
                    });
                });
                
                npr.then(async (msg)=>{
                    if(msg){
                        // registramos el proceso de la ordop
                        try {
                            this.mShowModal(this.idModalProgress);
                            this.dts_complaints.type =this.aux_type.id;
                            
                            this.dts_complaints.complaint=[];
                            this.cGetPersonComplaint.forEach(el => {
                                if(el.type_select === 'D'){
                                    this.dts_complaints.complaint.push(el);    
                                }
                            });

                            this.dts_complaints.knowdenounced=this.knowDenounced.value;
                            if(this.knowDenounced.value){
                                // console.log(this.knowDenounced.value);
                                // si es verdad almacenamos el array
                                this.dts_complaints.denounced=[];
                                
                                this.cGetPersonComplaint.forEach(vi => {
                                    if(vi.type_select === 'S'){
                                        // console.log(vi);
                                        this.dts_complaints.denounced.push(vi);    
                                    }
                                });
                                // console.log(this.dts_complaints.denounced);
                            }else{
                                // si es falso solamente el texto de descripcion
                                this.dts_complaints.denounced=[];
                            }
                            
                            this.dts_complaints.knowvictim=this.knowVictim.value;
                            if(this.knowVictim.value){
                                // si es verdad almacenamos el array
                                
                                
                                this.dts_complaints.victim=[];
                                this.cGetPersonComplaint.forEach(el => {
                                    if(el.type_select === 'V'){
                                        this.dts_complaints.victim.push(el);    
                                    }
                                    
                                });
                                
                            }else{
                                // si es falso solamente el texto de descripcion
                                this.dts_complaints.victim=[];
                            }

                            // console.log(this.dts_complaints);
                            // this.process_ordop.load=JSON.stringify(this.loads_declare);
                            // this.readonly_btn=true;
                            // console.log(this.newParameter);
                            // let dts={
                            //     detail:this.newParameter
                            // }
                            console.log(this.dts_complaints);
                            let s_new_denounce=await axios.post(`registerNewDenounce?api_token=${Vue.auth.getToken()}`, qs.stringify(this.dts_complaints));
                                if(s_new_denounce.data.status){
                                        toastr.success(s_new_denounce.data.respuesta, 'Exito');                                    
                                        this.mClearFormRegister();                                        
                                        setTimeout(()=>{                                            
                                            this.mCloseModal(this.idModalProgress);
                                            this.modalRepContent='';
                                            this.idReporte=s_new_denounce.data.id_rep;
                                            // this.mModalReportShow();
                                            this.mShowModal(this.idModalReport);
                                        },1000)
                                }else{
                                        toastr.error(s_new_denounce.data.respuesta, 'Error')
                                        setTimeout(()=>{                                            
                                            this.mCloseModal(this.idModalProgress);
                                        },1000)
                                }                              

                        }catch(err){
                            console.log(err);
                            setTimeout(()=>{
                                toastr.error('Ha ocurrido un error en el proceso', 'Error D-01')
                                setTimeout(()=>{
                                    
                                    this.mCloseModal(this.idModalProgress);
                                },500)
                            }, 3000)
                        }
                    }else{
                        console.log('No se guardo la denuncia')
                        // console.log(this.s_pro_ordop);
                        // toastr.warning(s_new_param.data.respuesta, 'Error');                                    
                    }
                })
            }
        },
        mClearFormRegister(){
            this.aux_time=null;
            this.dts_complaints.captain=0,
            this.dts_complaints.type=0,
            this.dts_complaints.detail_done=null,
            this.dts_complaints.date=null,
            this.dts_complaints.time=null;
            this.dts_complaints.site_done=null;
            this.dts_complaints.complaint=[],
            this.dts_complaints.denounced=[],
            this.dts_complaints.victim=[],
            this.dts_complaints.knowdenounced=true,
            this.dts_complaints.knowvictim=true,
            this.dts_complaints.descriptionDenounced=null,
            this.dts_complaints.descriptionVictim=null
            this.$store.dispatch('sComplaintsPersons/deletePersonsType', 'D');
            this.$store.dispatch('sComplaintsPersons/deletePersonsType', 'S');
            this.$store.dispatch('sComplaintsPersons/deletePersonsType', 'V');
        },
        mRegNewParam(){
            this.mShowModal(this.parModalRegGlobal.id);
        }, 
        async mCallTypesComplaint(){
            this.types_denounce=[];
            let rcom=await axios.get(`globals/complaint?api_token=${Vue.auth.getToken()}`);
            let cp=await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            // console.log(rcom);
            this.types_denounced=rcom.data;
            this.ports=cp.data;
        },
        mInitTooltip(){
            $('[data-toggle="tooltip"]').tooltip();
        },
        mShowSearchPerson(t='D', tt='DENUNCIANTE'){
            // console.log(t);
            this.typeSelectPerson=t;
            this.titleModal=tt;
            this.mShowModal(this.idModalSearchPerson);            
        },
        mShowSearchPersonEdit(t='D', tt='DENUNCIANTE'){
            // console.log(t);
            this.typeSelectPersonEdit=t;
            this.titleModalEdit=tt;
            this.mShowModal(this.idModalSearchPersonEdit);            
        },
        mRegisterPerson(){
            this.mShowModal(this.idModalNewPerson);
        },
        mShowModal(idM){
            $('#'+idM).modal('show');
        },
        mCloseModal(idM){
            $('#'+idM).modal('hide');
        },
        mRemovePerson(e){
            this.$store.dispatch('sComplaintsPersons/deletePersonComplaint', e);
        },
        mRemovePersonEdit(e){
            this.$store.dispatch('sComplaintsPersonsEdit/deletePersonComplaintEdit', e);
        },
        mKnowDenounced(){
            this.knowDenounced.value=!this.knowDenounced.value;
            if(this.knowDenounced.value){
                this.knowDenounced.text='SI';
                this.dts_complaints.descriptionDenounced=null;
            }else{
                this.knowDenounced.text='NO';
                this.$store.dispatch('sComplaintsPersons/deletePersonsType', 'S');
            }
        },
        mKnowVictim(){
            this.knowVictim.value=!this.knowVictim.value;
            if(this.knowVictim.value){
                this.knowVictim.text='SI';
                this.dts_complaints.descriptionVictim=null;
            }else{
                this.knowVictim.text='NO';
                this.$store.dispatch('sComplaintsPersons/deletePersonsType', 'V');
            }
        }
    },
    computed:{
        cGetPersonComplaint(){
            return this.$store.getters['sComplaintsPersons/getPersonComplaint'];
        },
        cGetPersonComplaintEdit(){
            return this.$store.getters['sComplaintsPersonsEdit/getPersonComplaintEdit'];
        },
        cDtsUser(){
            return this.$store.getters.getUserState;
        }
    },
    components:{
        'modal-search-person':modalSearchPerson,
        'modal-new-person':modalNewPerson,
        'modal-reg-global':modalRegGlobal,
        'modal-loading':modalLoading,
        'modal-report':modalReport
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/complaints/Complaints.vue